import { Controller } from '@hotwired/stimulus'
import { useDebounce } from "stimulus-use"
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static debounces = ['onSearchKeydown']

  connect() {
    useDebounce(this)
    this.element[this.identifier] = this
  }

  onSearchKeydown(e) {
    const request = new FetchRequest('get', `/admin/customers/search?query=${e.target.value}`, { responseKind: 'turbo-stream' })
    request.perform()
  }
}